/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import AdvancedSearch from "./Components/NewAdvanceSearch";
import styles from "./SearchOnlineContributionPrintForm.styles";
import DateRangePicker from "./Components/DateRangePicker/DateRangePicker";
import Popover from "../Components/Popover/NewPopover";
import { SERVICES } from "../../../components/Layout/Services";
import Loader from "../../../components/Loader/Loader";
import SearchIconWithPeople from "../../../components/Svg/SearchIconWithPeople";
import PageSyncCal from "../../../components/Layout/PageSyncCal";
import Heading from "../../../components/Layout/Heading";
import { OuterContainerStyles } from "../../../components/Layout/Typography";
import { post } from "../../../components/Layout/ApiHandler/apihandler";
import Button from "../../../components/Layout/Button";
import { ToastAlertContext } from "../../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../../contants";

const initialFormValue = {
  dateOfBirthFrom: new Date(),
  dateOfBirthTo: new Date(),
  dateOfJoiningFrom: "",
  dateOfJoiningTo: "",
  appointedAtFrom: "",
  appointedAtTo: "",
  conferralDateFrom: "",
  conferralDateTo: "",
};

function SearchOnlineContributionPrintForm() {
  const TITLE = "Search Online Contribution Print Form - BSG ContributionAdmin";
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef(null);
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);

  const [amountFromValue, setAmountFromValue] = useState(null);
  const [amountToValue, setAmountToValue] = useState(null);
  const toast = useContext(ToastAlertContext);
  const location = useLocation();
  const handleAmountFromChange = (value) => {
    setAmountFromValue(value);
  };
  const handleAmountToChange = (value) => {
    setAmountToValue(value);
  };

  function formatDateToYYYYMMDD(date) {
    return moment(date).format("YYYY-MM-DD");
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    if (
      !initialAdvanceFormValue.dateOfBirthFrom ||
      !initialAdvanceFormValue.dateOfBirthTo
    ) {
      toast.show("Please select date", AlertStatus.ERROR);
      return;
    }

    const formattedStartDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.dateOfBirthFrom,
    );
    const formattedEndDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.dateOfBirthTo,
    );

    try {
      const url = SERVICES.DOWNLOAD_BANK_DEPOSIT_SLIP;
      const data = {
        from: formattedStartDate,
        to: formattedEndDate,
        amountFrom: amountFromValue || null,
        amountTo: amountToValue || null,
      };
      const response = await post(url, data);
      if (response.ok) {
        toast.show(
          "Reports Generation started successfully. Please check under Reports > Download section",
          AlertStatus.SUCCESS,
        );
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };
  return (
    <div style={{ width: "100%", overflowX: "auto", overflowY: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      <Heading title="Search Online Contribution Print Form" />
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <div style={styles.container}>
          <div style={styles.filter}>
            <form style={styles.left} onSubmit={onSubmit} ref={formRef}>
              <DateRangePicker
                label="Date"
                name="date"
                startDateVal={initialAdvanceFormValue.dateOfBirthFrom}
                endDateVal={initialAdvanceFormValue.dateOfBirthTo}
                onChange={(startDate, endDate) => {
                  setInitialAdvanceFormValue({
                    ...initialAdvanceFormValue,
                    dateOfBirthFrom: startDate,
                    dateOfBirthTo: endDate,
                  });
                }}
              />
              <Popover heading="Amount Filters" minWidth={413}>
                <AdvancedSearch
                  onAmountFrom={handleAmountFromChange}
                  amountFromValue={amountFromValue}
                  onAmountTo={handleAmountToChange}
                  amountToValue={amountToValue}
                />
              </Popover>
              <Button type="submit">Search</Button>
            </form>
          </div>
          <div style={styles.main}>
            <div style={styles.initialContent}>
              <SearchIconWithPeople width={100} />
              <span style={styles.text}>Choose your Search Filter</span>
            </div>
          </div>
          {isLoading && <Loader />}
        </div>
      </OuterContainerStyles>
    </div>
  );
}

export default SearchOnlineContributionPrintForm;
